import { ICounter } from '../../components/Counter/interfaces';
import { ISelectItemWithEventMetrika } from '../Interfaces';

export const MetaTags = {
  main: {
    title: 'Курьерская служба доставки заказов по Москве и России “Dalli”',
    description:
      'Курьерская служба доставки заказов Dalli поможет вашим клиентам быстро получить товары из интернет-магазина в любой точке России. Надежно. Быстро. Полный комплекс услуг.',
  },
  delivery: {
    title: 'Услуги компании Dalli | Курьерская служба доставки заказов по Москве и России',
    description:
      'Услуги Dalli – полный список услуг. Dalli является одной из ведущих логистических компаний, предлагающих широкий спектр услуг в области грузоперевозок, складирования и логистики.',
    // meta: {
    //   name: {
    //     keywords: '',
    //   },
    // },
  },
  integration: {
    title: 'Личный кабинет - Dalli | Курьерская служба доставки заказов по Москве и России',
    description:
      'Доступ в личный кабинет предоставляется после заключения договора, так же вы можете запросить тестовый доступ для ознакомления с функционалом ЛК. В случае возникновения вопросов по использованию личного кабинета, обратитесь по телефону - 8 (495) 646-86-82 доб. 100.',
  },
  tracking: {
    title: 'Отслеживание заказа по трек номеру – Dalli',
    description:
      'Отследить доставку товаров и документов по Москве и России. Введите трек номер и мгновенно узнайте статус своего заказа.',
  },
  about: {
    title: 'О компании - Dalli | Курьерская служба доставки заказов по Москве и России',
    description:
      'Dalli - на шаг впереди ожидания – курьерская служба, специализирующаяся на доставке заказов интернет-магазинов в Москве и Санкт-Петербурге, а также Московской и Ленинградской областях.',
  },
  live: {
    title: 'Полезные статьи от компании Dalli - курьерская служба доставки заказов по Москве и России',
    description:
      'Блог службы доставки Dalli: полезные и интересные статьи для малого, среднего и крупного бизнеса о сфере логистики, транспорта и бизнеса.',
  },
  vacancies: {
    title: 'Вакансии - Dalli | Курьерская служба доставки заказов по Москве и России',
    description:
      'Вакансии - Dalli | Курьерская служба доставки заказов по Москве и России. Приходите, мы ждем вас на собеседование +7 (495) 181-08-31 Отдел кадров hr@dalli-service.com.',
  },
  tariffs: {
    title: 'Калькулятор доставки Dalli – рассчитать стоимость онлайн',
    description:
      'Калькулятор курьерской доставки – быстрый расчет стоимости доставки товаров по Москве и России. Простой и точный способ узнать стоимость транспортировки онлайн.',
  },
  contacts: {
    title: 'Контакты - Dalli-Service',
    description:
      'Контакты Чтобы мы ответили вам быстрее, обращайтесь адресно: Телефон в Москве Телефон в Санкт-Петербурге Отдел продаж Поддержка и информация по заказам Адрес в Москве г. Москва, шоссе Энтузиастов 31с50 МоскваЯндекс Карты — транспорт, навигация, поиск мест От Метро Шоссе Энтузиастов (3 выход) Выходите из метро и идете прямо вдоль здания до конца (Шоссе Энтузиастов 31). С',
  },
  reviews: {
    title:
      'Отзывы о курьерской службы Dalli для интернет-магазина, узнайте отзывы о работе курьерской службы',
    description:
      'Мнения о Dalli Service среди наших клиентов – сотни ведущих ритейлеров по всей России. Мы работаем по Москве и России, обеспечивая высокое качество обслуживания покупателей для интернет-магазинов. Профессиональные сотрудники, налаженная логистика и выгодные тарифы – наши преимущества, которые обеспечивают плодотворное и долгосрочное сотрудничество со всеми нашими партнерами.',
  },
  cashService: {
    title: 'Кассовое обслуживание - Dalli | Курьерская служба доставки заказов по Москве и России',
    description:
      'Кассовое обслуживание для e-commerce. Dalli предлагает кассовое обслуживание интернет-магазинов и строгую отчетность по всем платежам, которые поступают от момента оформления заказа до наложенного платежа при получении клиентом посылки.',
  },
  returnDocs: {
    title: 'Возврат сопроводительных документов – гарантии доставки от Dalli',
    description:
      'Возврат сопроводительных документов для магазинов – доставка курьером по Москве и в другие города России. Преимущества сотрудничества со службой доставки Dalli: схема работы, тарифы, особенности.',
  },
  clients: {
    title: 'Клиенты - Dalli | Курьерская служба доставки заказов по Москве и России',
    description:
      'Наши клиенты. Мы работаем с разными представителями ритейла, как с локальными магазинами, так и с лидерами в своей отрасли. Нам доверяют более 700 интернет-магазинов – присоединяйтесь и вы!',
  },
  questions: {
    title: 'Часто задаваемые вопросы - Dalli | Курьерская служба доставки заказов по Москве и России',
    description:
      'Ответы на часто задаваемые вопросы - Dalli | Курьерская служба доставки заказов по Москве и России.',
  },
  docs: {
    title: 'Документы - Dalli | Курьерская служба доставки заказов по Москве и России',
    description:
      'Тарифы на курьерскую доставку, ПВЗ, постоматы, отправку почтой России. Договоры, приложения к договору. Курьерская служба доставки заказов Dalli по Москве и России.',
  },
  deliveryMsk: {
    title: 'Курьерская доставка для интернет-магазинов по Москве и Московской области',
    description:
      'Курьерская доставка для интернет-магазинов. Доставляйте заказы своим покупателям в столице и Подмосковье качественно и надежно. Простое подключение интернет-магазина к службе доставки Dalli.',
  },
  deliveryMskToSpb: {
    title: 'Курьерская доставка Москва-Санкт-Петербург',
    description:
      'Доставка из Москвы в Санкт-Петербург и ЛО. Доставляйте заказы до двери получателя уже на следующий день после отправки! Четкое выполнение сроков и оперативность особенно ценны для покупателей интернет-магазинов из соседних регионов.',
  },
  deliverySpb: {
    title: 'Доставка по Санкт-Петербургу для интернет-магазинов',
    description:
      'Оперативная доставка из интернет-магазинов службой Dalli. Заказать курьерскую доставку по СПб. Разовые и регулярные поставки из интернет-магазинов – прямо к дверям.',
  },
  deliverySameDay: {
    title: 'Быстрая доставка день в день для интернет-магазинов, экспресс доставка за 1 день',
    description:
      'Служба доставки Dalli оказывает услуги доставки для интернет-магазинов день в день по Москве и Санкт-Петербургу. Низкие цены, ответственный подход к срокам без выходных и праздников.',
  },
  deliveryShipFromStore: {
    title: 'Доставка для офлайн магазинов от курьерской службы Dalli',
    description:
      'Компания Dalli оказывает услуги курьерской доставки товаров в любой регион России ритейлерам, занимающимся дистанционными продажами. Быстрая доставка для оффлайн магазинов.',
  },
  deliveryRu: {
    title: 'Доставка товаров по России от курьерской службы Dalli',
    description:
      'Требуется доставка товаров по России от интернет-магазина или со склада? «Dalli» подберет оптимальные условия грузоперевозочных услуг и обеспечит наилучшее качество обслуживания',
  },
  deliveryPVZ: {
    title: 'Пункт выдачи заказов интернет-магазинов – подключить доставку к ПВЗ',
    description:
      'Служба доставки Dalli предлагает подключить ваш интернет-магазин к услуге доставки товаров в пункты выдачи заказов. Более 2000 ПВЗ по всей территории России в вашем распоряжении.',
  },
  deliveryOutsourcing: {
    title: 'Аутсорсинг доставки для интернет-магазинов от "Dalli"',
    description:
      'Услуги аутсорсинга доставки для e-commerce сектора позволят не терять покупателей и сэкономить на содержании целого штата собственных курьеров. Dalli Service предлагает аутсорсинг курьеров, которые профессионально доставят заказы ваших покупателей по указанному адресу или в пункты выдачи.',
  },
  deliveryComprehensiveService: {
    title:
      'Обслуживание интернет-магазинов – цена на услуги по обслуживанию интернет-магазина Москве, МО, СПб и всей России',
    description:
      'Интернет-магазин может работать быстрее и лучше, если служба доставки и кассовое обслуживание работают единым механизмом. Если вы не хотите тратить лишнее время и деньги на обучение персонала и финансирование целого штата сотрудников – обслуживание интернет-магазинов на аутсорсе станет идеальным решением.',
  },
  deliveryLogistics: {
    title: 'Логистика для интернет-магазинов, логистические услуги в Москве, МО, СПб и всей России',
    description:
      'Логистика для интернет-магазинов является одной из самых важных составляющих успешного бизнеса наравне с закупкой товаров и маркетингом. Своевременная доставка товара из магазина покупателю – это задача "Dalli".',
  },
  policy: {
    title: 'Политика конфиденциальности - Dalli-Service',
    description: 'Данные, собираемые при посещении сайта Dalli-Service',
  },
  gallery: {
    title: 'Фотогалерея - Dalli | Курьерская служба доставки заказов по Москве и России',
    description: 'Фотогалерея службы доставки Dalli | Курьерская служба доставки заказов по Москве и России',
  },
  deliverySZFO: {
    title: 'Доставка в Северо-Западный федеральный округ (СЗФО) | Dalli',
    description:
      'Оперативная курьерская доставка товаров из интернет-магазинов службой Dalli. Заказать курьерскую доставку из Москвы и Санкт-Петербурга в Северо-Западный федеральный округ (СЗФО)',
  },
  deliveryCFO: {
    title: 'Доставка в Центральный федеральный округ (ЦФО) | Dalli',
    description:
      'Оперативная курьерская доставка товаров из интернет-магазинов службой Dalli. Заказать курьерскую доставку из Москвы и Санкт-Петербурга в Центральный федеральный округ (ЦФО)',
  },
  deliveryUFO: {
    title: 'Доставка в Южный федеральный округ (ЮФО) | Dalli',
    description:
      'Оперативная курьерская доставка товаров из интернет-магазинов службой Dalli. Заказать курьерскую доставку из Москвы и Санкт-Петербурга в Южный федеральный округ (ЮФО)',
  },
  deliveryPFO: {
    title: 'Доставка в Приволжский федеральный округ (ПФО) | Dalli',
    description:
      'Оперативная курьерская доставка товаров из интернет-магазинов службой Dalli. Заказать курьерскую доставку из Москвы и Санкт-Петербурга в Приволжский федеральный округ (ПФО)',
  },
  deliveryUrFO: {
    title: 'Доставка в Уральский федеральный округ (УФО) | Dalli',
    description:
      'Оперативная курьерская доставка товаров из интернет-магазинов службой Dalli. Заказать курьерскую доставку из Москвы и Санкт-Петербурга в Уральский федеральный округ (УФО)',
  },
};

export const AddressMsk = 'шоссе Энтузиастов, 31с50';
export const AddressSpb = 'Лиговский проспект, 50 литера «Н», п.116';

export const MainStatistic: ICounter[] = [
  { count: 1000, unit: '+', text: 'городов по всей стране' },
  { count: 98.1, unit: '%', text: 'довольных получателей', fraction: 1 },
  { count: 98.3, unit: '%', text: 'заказов доставлены в срок', fraction: 1 },
  { count: 1000, unit: '+', text: 'интернет-магазинов уже с нами' },
];

export const LinkDzen = 'https://dzen.ru/dalli';
export const LinkYoutube = 'https://www.youtube.com/@dalliservice2053';
export const LinkVk = 'https://vk.com/dalliservicecom';
export const LinkTg = 'https://t.me/Dalli_news';
export const LinkWhatsapp = '';

export const ListUriLive = ['news', 'news-company', 'news-mass-media', 'news-ecom-delivery'];

export const METRIKA_ASK_QUESTION_FORM = 'form_feedback_complaints';

export const SelectValuesFormSimple: ISelectItemWithEventMetrika[] = [
  { value: 0, label: 'Вопрос по заказу', eventMetrika: METRIKA_ASK_QUESTION_FORM },
  { value: 1, label: 'Подключить доставку', eventMetrika: 'form_partner' },
];

export const TimeSend = '_ks_ds_tform';

export const textareaMaxSymbols = 500;
